// extracted by mini-css-extract-plugin
module.exports = {"head":"Terms_head__3UBgB","title":"Terms_title__1gg2J","store":"Terms_store__jbUug","grop":"Terms_grop__2R8WU","privacyBorder":"Terms_privacyBorder__qRXUT"};